import { render, staticRenderFns } from "./multipleselect.vue?vue&type=template&id=06d3afb3"
import script from "./multipleselect.vue?vue&type=script&lang=js"
export * from "./multipleselect.vue?vue&type=script&lang=js"
import style0 from "./multipleselect.vue?vue&type=style&index=0&id=06d3afb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports